<script>
import BaseAutocomplete from '@/components/elements/Base/BaseAutocomplete';
import CategoryService from '@/services/category-service.js';

export default {
	extends: BaseAutocomplete,
	name: 'autocomplete-category',
	methods: {
		itemHasChanged(category) {
			this.$emit('update:category', category);
		},
		request() {
			return CategoryService.getAll;
		},
		customLabel(category) {
			return category.title;
		},
		setSelection() {
			this.getAutocomplete(this.request, '');
			this.currentSelection = this.selected;
		}
	}
}
</script>



// WEBPACK FOOTER //
// AutocompleteCategory.vue?5664fdcd